import { IEtapaPontoRescisao } from './rescisao.ponto.service.model';

export enum RescisaoPontoEtapa {
    INICIAL = 1,
    ENVIO_PARA_RESPONSAVEL = 2,
    PONTO_TRATADO = 3,
    FOLHAS_GERADAS = 4,
    MOVIMENTOS_GERADOS = 5,
    FINAL = 6,
}

export type StepDetail = 1 | 2 | 3 | null;

export type Step = {
    etapa: RescisaoPontoEtapa,
    etapadetalhe: StepDetail;
};

export type StepHistory = {
    [key: string]: IEtapaPontoRescisao | null;
    etapa_1: IEtapaPontoRescisao | null,
    etapa_2: IEtapaPontoRescisao | null,
    etapa_3: IEtapaPontoRescisao | null,
    etapa_4: IEtapaPontoRescisao | null,
    etapa_5: IEtapaPontoRescisao | null,
    etapa_6: IEtapaPontoRescisao | null,
};

export type ChecklistStatus = 'pending' | 'active' | 'completed';

export type ChecklistItem = {
    key: string;
    status: ChecklistStatus;
    iconClass: string;
    title: string;
    subtitle?: string;
    hint?: string;
    showExternalLink?: boolean;
    showTags?: boolean;
    showResendAction?: boolean;
};
